module.exports = __webpack_public_path__ + "static/media/usb-c-silver.24a89b77.svg";